import { render, staticRenderFns } from "./Compulsas.vue?vue&type=template&id=98982c88&scoped=true"
import script from "./Compulsas.vue?vue&type=script&lang=js"
export * from "./Compulsas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98982c88",
  null
  
)

export default component.exports